// Location popup functionality
let popup = null;
let hasShown = false;
const sessionKey = 'location_popup_dismissed';

function init() {
  console.log('Initializing location popup...');
  
  // Check if popup was already dismissed in this session
  const dismissed = sessionStorage.getItem(sessionKey);
  console.log('Session storage check:', sessionKey, '=', dismissed);
  
  if (dismissed) {
    console.log('Popup was already dismissed in this session');
    return;
  }

  // Create popup HTML
  createPopup();
  
  // Detect user location
  detectLocation();
}

function createPopup() {
    const popupHTML = `
      <div class="location-popup" id="locationPopup">
        <div class="location-popup__content">
          <button class="location-popup__close" id="locationPopupClose">&times;</button>
          <h2 class="location-popup__title">Welcome to our store! 🌍</h2>
          <p class="location-popup__message">
            You have visited our swedish store, if you want your coffee delivered outside of Sweden visit our EU store with fast shipping all over Europe.
          </p>
          <div class="location-popup__buttons">
            <button class="location-popup__button" id="continueButton">Stay on Swedish store</button>
            <button class="location-popup__button location-popup__button--secondary" id="navigateButton">Go to EU store</button>
          </div>
        </div>
      </div>
    `;
  // Add popup to body
  document.body.insertAdjacentHTML('beforeend', popupHTML);
  popup = document.getElementById('locationPopup');

  // Add event listeners
  addEventListeners();
}

function addEventListeners() {
  const closeBtn = document.getElementById('locationPopupClose');
  const continueBtn = document.getElementById('continueButton');
  const navigateBtn = document.getElementById('navigateButton');

  closeBtn.addEventListener('click', () => dismissPopup());
  continueBtn.addEventListener('click', () => dismissPopup());
  navigateBtn.addEventListener('click', () => navigate());
  
  // Close on background click
  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      hidePopup();
    }
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup && popup.classList.contains('show')) {
      hidePopup();
    }
  });
}

function detectLocation() {
  console.log('Starting location detection...');
  
  // Use Shopify's browsing context suggestions for location detection
  fetch("/browsing_context_suggestions.json")
    .then(response => {
      console.log('Response received:', response.status);
      return response.json();
    })
    .then(data => {
      console.log('Location data:', data);
      const country = data.detected_values.country.handle; // e.g. "SE"
      console.log('Detected country:', country);
      
      if (country !== "SE") {
        console.log('Non-Swedish user detected, showing popup');
        showPopup();
      } else {
        console.log('Swedish user detected, not showing popup');
      }
    })
    .catch((error) => {
      console.log('Location detection failed, using fallback:', error);
      // Fallback: check browser language
      const browserLang = navigator.language || navigator.userLanguage;
      console.log('Browser language:', browserLang);
      
      if (browserLang && !browserLang.toLowerCase().startsWith('sv')) {
        console.log('Non-Swedish browser language, showing popup');
        showPopup();
      } else {
        console.log('Swedish browser language, not showing popup');
      }
    });
}

function showPopup() {
  console.log('showPopup called');
  console.log('hasShown:', hasShown, 'popup exists:', !!popup);
  
  if (hasShown || !popup) {
    console.log('Popup not shown - hasShown:', hasShown, 'popup exists:', !!popup);
    return;
  }
  
  hasShown = true;
  console.log('Setting hasShown to true');
  
  // Add CSS if not already added
  if (!document.querySelector('link[href*="location-popup.css"]')) {
    console.log('Adding CSS file');
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = window.Shopify?.routes?.root ? 
      `${window.Shopify.routes.root}assets/location-popup.css` : 
      '/assets/location-popup.css';
    document.head.appendChild(link);
  } else {
    console.log('CSS file already exists');
  }
  
  console.log('About to show popup with animation');
  // Show popup with animation
  setTimeout(() => {
    console.log('Adding show class to popup');
    popup.classList.add('show');
    document.body.style.overflow = 'hidden';
  }, 500); // Small delay to ensure page is loaded
}

function hidePopup() {
  if (!popup) return;
  
  popup.classList.remove('show');
  document.body.style.overflow = '';
  
  setTimeout(() => {
    if (popup && popup.parentNode) {
      popup.parentNode.removeChild(popup);
    }
  }, 300);
}

function dismissPopup() {
  // Set session storage to remember dismissal for this session
  sessionStorage.setItem(sessionKey, 'true');
  hidePopup();
}

function navigate() {
  // Redirect to EU site
  window.location.href = 'https://coffydoor.eu';
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
} else {
  init();
}